import type { ProjectArtifactScope } from '../types';

/**
 * Map an artifact's display scope to its column label (OR-6615). ``org`` and
 * ``global`` both read "Organization"; everything else (incl. an absent
 * scope) reads "Project". Pure — no React.
 */
export const scopeToLabel = (
  scope: ProjectArtifactScope | null | undefined
): 'Project' | 'Organization' =>
  scope === 'org' || scope === 'global' ? 'Organization' : 'Project';

/** True when the row is an organization-scoped asset (org or Verantos global). */
export const isOrganizationScope = (scope: ProjectArtifactScope | null | undefined): boolean =>
  scope === 'org' || scope === 'global';
